import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  getSimilarAds,
  selectSimilarAds
} from "../../../../routes/Ad/ad.ducks";
import { selectFavoriteIds } from "../../../../routes/Favorite/favorite.ducks";
import styles from "./similarAdsSection.scss";
import SimilarAdsCarousel from "./SimilarAdsCarousel";

const SimilarAdsQuantity = 8;

function SimilarAdsSection(props) {
  const {
    favoriteIds,
    adId,
    similarAds,
    category,
    setLoadingSimilar,
    hasFavorite,
    noBackground,
    module
  } = props;

  useEffect(() => {
    setLoadingSimilar(true);
    props.getSimilarAds(
      adId,
      favoriteIds,
      SimilarAdsQuantity,
      () => setLoadingSimilar(false),
      module,
      category
    );
  }, [
    favoriteIds,
    JSON.stringify(similarAds) != JSON.stringify([])
  ]);

  if (similarAds.length < 1) {
    return null;
  }

  return (
    <div className={styles.container} style={noBackground ? { background: "none" } : {}}>
      <div className={styles.title}>
        {"Slični oglasi"}
      </div>
      <SimilarAdsCarousel category={category} similarAds={similarAds} hasFavorite={hasFavorite} noBackground={noBackground} />
    </div>
  );
}

export default connect(
  state => ({
    similarAds: selectSimilarAds(state),
    favoriteIds: selectFavoriteIds(state)
  }),
  { getSimilarAds }
)(SimilarAdsSection);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SimilarAdsSection/index.tsx